'use client';

import usePrimeStore from '@/lib/state-stores/primeStore';
import { useTranslations } from 'next-intl';
import CarIcon from '@/public/assets/Car.svg';
import Image from 'next/image';
import SaudiRealls from '@/components/sarComponent';

const usePrimeStatus = () => {
  const { prime } = usePrimeStore();
  return prime?.activeSubscription && prime?.primeEnabled;
};

export const FreeDeliveryBadge = () => {
  const isPrimeActive = usePrimeStatus();
  const t = useTranslations('stores');

  if (!isPrimeActive) return null;

  return (
    <span className="border-purple flex h-6 items-center justify-center space-x-1 rounded-md border bg-[#ECE9FF] p-2 text-black lg:p-3 rtl:space-x-reverse">
      <Image src={CarIcon} alt="CarIcon" width={16} height={16} />
      <p className="text-purple text-[10px] font-bold">{t('free')}</p>
    </span>
  );
};

export const FreeDeliveryText = ({ deliveryFee }: { deliveryFee: number }) => {
  const isPrimeActive = usePrimeStatus();
  const t = useTranslations('stores');

  return isPrimeActive ? (
    <div className="flex gap-2">
      <div className="text-sm font-bold text-[#868687] line-through">
        <SaudiRealls price={deliveryFee} size="small" />
      </div>
      <p className="text-sm font-bold text-[#018748]">{t('free')}</p>
    </div>
  ) : (
    <div className="text-sm font-bold">
      <SaudiRealls price={deliveryFee} size="small" />
    </div>
  );
};
